import React from "react";
import { MagicWand } from "@phosphor-icons/react";

function MappingRow({ header, sample, canonicalFields, mapping, setOne }) {
  return (
    <div className="grid grid-cols-3 border-b border-zinc-200" data-testid={`csv-row-${header}`}>
      <div className="px-3 py-2 font-mono text-xs">{header}</div>
      <div className="px-3 py-2 font-mono text-xs border-l border-zinc-200 text-zinc-600 truncate">
        {sample || "—"}
      </div>
      <div className="border-l border-zinc-200">
        <select data-testid={`csv-map-${header}`}
          className="w-full px-2 py-2 text-xs font-mono border-0"
          value={mapping[header] || ""}
          onChange={(e) => setOne(header, e.target.value)}>
          <option value="">— skip —</option>
          {canonicalFields.map((f) => <option key={f} value={f}>{f}</option>)}
        </select>
      </div>
    </div>
  );
}

/**
 * CSV column → canonical-field mapping table. Header row + one row per
 * source column with a sample cell and a canonical-field dropdown.
 */
export default function CsvMappingTable({ preview, mapping, setOne, onAutoSuggest }) {
  const sampleRow = preview.preview_rows?.[0] || {};
  return (
    <>
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-widest">Field mapping</div>
        <button type="button" onClick={onAutoSuggest}
          className="border border-black px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white">
          <MagicWand size={10} className="inline" /> Auto-suggest
        </button>
      </div>
      <div className="border border-black" data-testid="csv-mapping-table">
        <div className="grid grid-cols-3 border-b border-black bg-zinc-100 text-[10px] uppercase tracking-widest">
          <div className="px-3 py-2">Source column</div>
          <div className="px-3 py-2 border-l border-black">Sample</div>
          <div className="px-3 py-2 border-l border-black">Canonical field</div>
        </div>
        <div className="max-h-[400px] overflow-y-auto">
          {preview.headers.map((h) => (
            <MappingRow
              key={h}
              header={h}
              sample={sampleRow[h]}
              canonicalFields={preview.canonical_fields}
              mapping={mapping}
              setOne={setOne}
            />
          ))}
        </div>
      </div>
    </>
  );
}
